import { Immutable } from "immer";
import React from "react";
import { RichText } from "tsi-common-react/src/components/RichText/index";
import { TempurLoveBreadcrumbs } from "tsi-common-react/src/components/TempurLoveBreadcrumbs/index";
import { UGCApiGrid } from "tsi-common-react/src/components/UGCApiGrid/index";

import { templates } from "@reactivated";

import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import styles from "./index.module.scss";

// The social-gallery body is composed inside the live
// CustomerContentHubSocialPageDocumentTemplate, which passes down this subset
// of its own props; derive the shape from it so the two stay in sync.
type IProps = Immutable<
    Pick<
        templates.CustomerContentHubSocialPageDocumentTemplate,
        "page_info" | "love_root_info" | "initial_ugc_data" | "initial_next_url"
    >
>;

export const CustomerContentHubSocialPage = (
    props: IProps,
): React.JSX.Element => {
    return (
        <>
            {/* Breadcrumbs */}
            <TempurLoveBreadcrumbs
                className="al-tlovesocial-breadcrumbs"
                items={[
                    {
                        title: props.love_root_info.title,
                        url: props.love_root_info.url || "/",
                    },
                    { title: props.page_info.title, isCurrentPage: true },
                ]}
                useCappedWidth={true}
            />

            {/* Description and UGC Grid */}
            <div
                className={concatClassNames([
                    "l-full-width",
                    "tempurlove-content",
                    styles.content,
                ])}
            >
                <div className="l-capped-width">
                    {props.page_info.description && (
                        <RichText
                            className={styles.description}
                            html={props.page_info.description}
                        />
                    )}
                    <article
                        className={concatClassNames([
                            "social-gallery",
                            "al-tlovesocial-ugcgrid",
                            styles.socialGallery,
                        ])}
                    >
                        <UGCApiGrid
                            pageSize={20}
                            initialGridData={props.initial_ugc_data}
                            initialNextUrl={props.initial_next_url}
                        />
                    </article>
                </div>
            </div>
        </>
    );
};
